import apiBaseUrl from '../../utils/config.js';

class AuthorizationHoldFlagService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/authorization-hold-flags`;
  }

  getToken() {
    return localStorage.getItem('jwt');
  }

  getAuthHeaders() {
    const token = this.getToken();

    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async request(endpoint, method = 'GET', body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body !== null && body !== undefined) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${this.baseUrl}${endpoint}`, options);
    const text = await response.text();

    let data = null;

    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = text;
      }
    }

    if (!response.ok) {
      const message =
        data?.message ||
        data?.error ||
        data ||
        `Request failed with status ${response.status}`;

      throw new Error(message);
    }

    return data;
  }

  async getAllDefinitions() {
    return this.request('/definitions');
  }

  async getActiveDefinitions() {
    return this.request('/definitions/active');
  }

  async createDefinition(payload) {
    return this.request('/definitions', 'POST', payload);
  }

  async updateDefinition(flagId, payload) {
    return this.request(`/definitions/${flagId}`, 'PUT', payload);
  }

  async deleteDefinition(flagId) {
    return this.request(`/definitions/${flagId}`, 'DELETE');
  }

  async getFlagsForHold(holdId) {
    return this.request(`/hold/${holdId}`);
  }

  async assignFlagToHold(holdId, flagId, staffId, note = '') {
    return this.request(`/hold/${holdId}`, 'POST', {
      flagId,
      staffId,
      note,
    });
  }

  async removeFlagFromHold(holdId, flagId) {
    return this.request(`/hold/${holdId}/flag/${flagId}`, 'DELETE');
  }
}

export default AuthorizationHoldFlagService;